import { WarningIcon } from "asset/icons";
import React from "react";

/**
 * ErrorMessage Component
 * @param {string} message - The error message to display (dynamic from backend)
 * @returns {JSX.Element}
 */
const ErrorMessage = ({ message }) => {
    if (!message) return null;

    return (
        <div className="flex items-center gap-2 !pt-2 !pb-4">
            <WarningIcon className="text-[#DC2626] w-5 h-5" />

            <span className="text-[#B91C1C] text-sm font-medium">{message}</span>
        </div>
    );
};

export default ErrorMessage;
